<template>
<div>    
    <v-card>
        <v-card-title v-html="header">
        </v-card-title>

        <v-card-text :class="$style.vCard">
            <v-form v-model="valid_form" ref="form">
                <div :class="$style.questions" v-html="body"/>
                <div v-html="subtext"/>
                
                <template v-for="(group, group_index) in question.config.groups">
                    <table :key="'group_'+group.id" :class="$style.percentageTable">
                        <thead>
                            <tr>
                                <th>
                                </th>
                                <template v-for='input in group.inputs'>
                                    <th :key="'group_'+group.id+'input_'+input.id" v-html="group_index==0 ? input.label[$language()] : ''">
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <!-- <td v-html="group.label[$language()] ? group.label[$language()]+' %' : '%'" > -->
                                <td>
                                    <div :class="$style.percentageGroupWrapper">
                                        <div :class="$style.percentageGroupLabel" v-html="group.label[$language()]" /> &nbsp; %
                                    </div>
                                </td>
                                <template v-for="input in group.inputs">
                                    <td :key="'group_'+group.id+'input_'+input.id" >
                                        <v-text-field 
                                            v-model="value[group.id][input.id]"                                 
                                            type="number"
                                            outlined
                                            :data-row="group.id"
                                            :data-column="input.id"
                                            :data-enforce-100="input.type_config ? input.type_config[question.config.type].enforce_100 : true"
                                            :disabled="disabled[group.id][input.id]"
                                            :rules="percentage.rules.isValid"
                                            :flat="true"
                                            :dense="true" 
                                            class="percentage-code-wrapper"                               
                                        >
                                            <span 
                                                slot="append">
                                                %
                                            </span>
                                        </v-text-field>
                                        <v-text-field class="percentage-code-wrapper" v-if="enableOther[group.id][input.id]" :autofocus="true" :disabled="!enableOther[group.id][input.id]" v-model="other[group.id][input.id]" :label="input.label[$language()]">
                                        </v-text-field>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <table style="position: relative;" :class="$style.percentageTable">
                    <tbody>
                        <tr>
                            <td>
                            </td>
                            <template v-for="(total, index) in percentage.tally">
                                <td :key="'question_'+question.config.id+'_total_'+index" v-if="enforce_100(index)">
                                    <div style="display: flex; align-items: center;">
                                        <completionBar :total="total" style="margin: 0 auto;"/>
                                    </div>
                                </td>
                                <td :key="'question_'+question.config.id+'_total_'+index" v-else>
                                    <completionBar :total="100" :enforce_100="enforce_100(index)"/>
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
                <div style="clear:both;"/>
            </v-form>
        </v-card-text>

        <v-card-text v-html="footer">
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import completionBar from "../assets/completionBar.vue";

const controller = require("./controllers/percentage.js").default;
const module_generator = require("./controllers/module_generator.js").default;

var module_config = module_generator('percentage-question',controller);
module_config.components = {
    completionBar
}
module_config.methods.enforce_100 = function(group_id){
    var isGroup = function(group){
        return group.id == group_id;
    }
    let group = this.question.config.groups.filter(isGroup)[0];
    var result = true;
    if(group){
        for(let i=0; i<group.inputs.length; i++ ){
            let input = group.inputs[i];
            if(group_id==input.id){
                return input.type_config ? input.type_config[this.question.config.type].enforce_100 : true;
            }
    
        }
    }
    return result;
}

export default module_config
</script>

<style module>
.vCard {
    padding: 0px 140px;
    width: 100%;
    margin: 19px 0;
}

.answers {
    margin: 8px 0px;
    width: 100%;
    height: 110px;
    display: flex;
    flex-direction: row;
}

.answersLabel {
    word-break: break-word;
    margin: 0px 15px;
    width: 210px;
    height: 92px;
    display: flex;
    align-items: center;
    
}

.answersLabelExisted {
    height: 92px;
}

.question{
    border: 1px solid slategray;
    border-radius: 3px;
    margin: 25px;
    padding: 15px;
    
}

.questions {
    font-size:18px;
    margin-bottom: 20px;
    color:black;
}

.percentageInputs {
    display: flex; 
    flex-direction: row;
}

.percentageInputWrapper {
    width: 100%;
    margin: 3px 5px; 
    height: 120px;
    display: flex;
    align-items: center;
    flex-direction: column;
}

.percentageInputsHeaderWrapper{
    min-height: 100px;
    max-height: 100px;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.percentageInputsHeaderWrapper h4 {
    white-space:normal;
}

.percentageGroupWrapper {
    display: flex; 
    flex-direction: row; 
    align-items: center;
}

.percentageGroupLabel p{
    margin-bottom: 0px !important;
}

.percentageTable thead tr th, .percentageTable tbody tr td{
    width: 250px;
}

@media only screen and (max-width: 1240px) {
    .vCard {
        padding: 0 100px;
    }
}

@media only screen and (max-width: 1145px) {
    .vCard {
        padding: 0 80px;
    }
}

@media only screen and (max-width: 1105px) {
    .vCard {
        padding: 0 30px;
    }
}

@media only screen and (max-width: 1000px) {
    .vCard {
        padding: 0 10px;
    }
}

@media only screen and (max-width: 980px) {

.questions {
    width: 95%;
}

.vCard {
    margin: 0px !important;
    width: 100%;
    padding: 0px 10px;
}

.answers {
    margin:0px !important;
}   
}
</style>

<style >

.percentage-code-wrapper {
    margin: 20px auto 0 !important;
    width: 80%;
}

.percentage-code-wrapper .v-input__append-inner {
    margin-top: 13px !important;
}
</style>